// product-card.js
document.addEventListener('DOMContentLoaded', function () {
  // Variant handling code
  const variantSelectors = document.querySelectorAll('.variant-select');

  variantSelectors.forEach(selector => {
    selector.addEventListener('change', function (event) {
      const selectedVariant = event.target.value;
      // Update hidden input or perform actions based on selected variant
      const hiddenInput = document.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = selectedVariant;
      }
    });
  });

  // Additional necessary JavaScript functionalities can be added here
});
